import { Component, OnInit, ViewChild, forwardRef, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import * as _ from 'lodash';

// const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MyDateInput),
  multi: true
};

// -- MyDateInput --
@Component({
  template: `<input 
    #input 
    readonly 
    ngbDatepicker 
    id="datePicker" 
    #d="ngbDatepicker" 
    [minDate]="minDate"
    [maxDate]="maxDate" 
    class="form-control" 
    (click)="d.toggle();" 
    [id]="formControlName" 
    [(ngModel)]="dateModel" 
    placeholder="YYYY-MM-DD" 
    [name]="formControlName" 
    (blur)="touchCallback()" 
    (ngModelChange)="onChange($event)" 
    [attr.disabled]="disabled?true:null"
  />`,
  selector: "my-date-input",
  host: {
    '(document:click)': 'handleOutsideClick($event)',
  },
  styles: [],
  providers: [DATE_VALUE_ACCESSOR]
})
export class MyDateInput implements ControlValueAccessor {

  date: Date;
  minDate: any;
  dateModel: any;
  disabled: boolean = false;
  isDisabled: boolean = true;
  maxDate: any;

  touchCallback = () => { };
  changeCallback = (data: any) => { };

  @ViewChild('d') dp;
  @Input() showPastDate: boolean;
  @Input() formControlName: any;
  @ViewChild("input") input: ElementRef;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  @Input() showFutureDate: boolean;
  @Input() showPastAndTodayDate:boolean;
  
  constructor() { }

  onChange(event) {
    let timestamp = this.convertToTimestamp(event);
    this.changeCallback(timestamp);
    this.notify.emit();
  }

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    if (this.showPastDate != null && this.showPastDate == false) {
      this.date = new Date();
      this.minDate = { year: this.date.getFullYear(), month: (this.date.getMonth() + 1), day: this.date.getDate() };
    }
    else if(this.showPastAndTodayDate != null && this.showPastAndTodayDate == false) {
      this.date = new Date();
      var nextDate= moment().add(1,'d');
      //this.minDate = { year: this.date.getFullYear(), month:parseInt(nextDate.format('M')), day: parseInt(nextDate.format('D')) };
      this.minDate = { year: parseInt(nextDate.format('Y')), month:parseInt(nextDate.format('M')), day: parseInt(nextDate.format('D')) };
    }
    else {
      this.minDate = '';
    }

    if (this.showFutureDate != null && this.showFutureDate == false) {
      this.date = new Date();
      this.maxDate = { year: this.date.getFullYear(), month: (this.date.getMonth() + 1), day: this.date.getDate() };
    }
    else {
      this.maxDate = '';
    }
  }

  convertToTimestamp(formatedDate) {
    if (formatedDate && formatedDate.year && formatedDate.day) {
      return moment([formatedDate.year, formatedDate.month - 1, formatedDate.day]).unix() * 1000
    }
    else {
      return null;
    }
  }

  convertToNBModel(obj) {
    let dt: any;
    if (/^[0-9]+$/.test(obj)) {  // if a milisecond timestamp
      dt = moment.unix(obj / 1000);
      return this.dateModel = { day: dt.date(), month: dt.month() + 1, year: dt.year() };
    }
    else if (moment(obj).isValid()) {
      dt = moment(obj);
      return this.dateModel = { day: dt.date(), month: dt.month() + 1, year: dt.year() };
    }
  }

  writeValue(obj: any) {
    if (obj != null) {
      this.input.nativeElement.value = this.convertToNBModel(obj);
    }
    else if (this.input && !_.isEmpty(this.input.nativeElement.value)) {
      this.input.nativeElement.value = null;
    }
  }

  registerOnChange(fn: any) {
    this.changeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.touchCallback = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  handleOutsideClick(event) {
    if(event.target.id == 'resetButton'){
      this.dateModel=null;
    }
    if (!this.dp.isOpen() || event.target.id == this.formControlName ||
      (event.target.offsetParent && event.target.offsetParent.localName.includes('ngb-datepicker')) ||
      !(event.target.parentElement && event.target.parentElement.parentElement && !event.target.parentElement.parentElement.localName.includes('ngb-datepicker'))
    ) {
      return;
    }
    if (this.dp.isOpen() && event.target.id != this.formControlName) {
      this.dp.close();
    }

  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/my-date-input/my-date-input.ts